<template>
	<div class="c frame bg-default c-explist" id="articles">
		<div class="container">
			<div class="c-filter__backdrop" @click="closeFilter"></div>
			<div class="c-filter">
				<div class="c-filter__label">{{ overviewSettings.FilterTitle }}</div>
				<div class="c-filter__items">
					<template v-if="isLoading">
						<div class="c-filter__item">
							<div class="c-filter__item--btn">
								<span class="c-filter__item--btn--name">{{ getFilterName('Sector') }}</span> <span class="c-filter__item--btn--amount">(0)</span>
							</div>
						</div>
					</template>
					<template v-else>
						<div v-for="(filter, filterName) in facets" :key="filterName" class="c-filter__item">
							<button :class="['c-filter__item--btn', { active: openFilter === filterName }]" type="button" :data-filtername="filterName" @click="toggleFilter">
								<span class="c-filter__item--btn--name">{{ getFilterName(filterName) }}</span>
								<span :class="['c-filter__item--btn--amount', { shown: checkedFacetsCount(filterName) > 0 }]">({{ checkedFacetsCount(filterName) }})</span>
							</button>
							<ul class="c-filter__item--list">
								<li v-for="(filterItem, filterIndex) in filter" :key="filterIndex" :class="{ lvl2: filterItem.value.includes('.'), active: isFilterValueChecked(filterName, filterItem.value) }">
									<input
										:id="'filter-' + filterName + '-' + filterIndex"
										type="checkbox"
										:value="filterItem.value"
										:checked="isFilterValueChecked(filterName, filterItem.value)"
										@change="updateFilters($event, filterName)"
									/>
									<label :for="'filter-' + filterName + '-' + filterIndex">{{ getSectorName(filterItem.value) }} ({{ filterItem.count }})</label>
								</li>
							</ul>
						</div>
						<div v-show="checkedFacets['Sector'] != null || checkedFacets['Theme'] != null" class="c-filter__item">
							<button type="button" class="c-filter__item--reset" @click="resetFilters">{{ overviewSettings.FilterReset }}</button>
						</div>
					</template>
				</div>
			</div>
			<div class="row">
                <template v-if="isLoading">
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <div class="c-explist__overview">
                            <div v-for="placeholder in parseInt(overviewSettings.PlaceholderCount)" :key="placeholder" class="c-explist__item c-placeholder">
                                <div class="c-explist__item--img"></div>
                                <div class="c-explist__item--inner"></div>
                            </div>
                        </div>
                    </div>
                </template>
				<div v-else class="col-12 col-xl-10 offset-xl-1">
					<div class="c-explist__overview">
						<experienceItem v-for="resultItem in searchResults" :result-item="resultItem" :key="resultItem.DocumentGuid"/>
					</div>
				</div>
			</div>
		</div>
		<paginationControlls :pageCount="pageCount" :hasPreviousPage="hasPreviousPage" :currentPage="currentPage" :hasNextPage="hasNextPage"/>
	</div>	
</template>
<script>
    import experienceItem from './experienceItem.vue';
    import paginationControlls from './paginationControlls.vue';
    export default {    
        components: {
		    experienceItem,
		    paginationControlls
	    },
        props: [ 
            'checkedFacets',
            'facets',
            'overviewSettings',
            'isLoading',
            'pageCount',
            'hasPreviousPage',
            'currentPage',
            'hasNextPage',
            'openFilter',
            'searchResults',
        ],
        methods:{
            getSectorName: function (name) {
                return this.$parent.getSectorName(name);
            },
            getFilterName: function (name) {
                return this.$parent.getFilterName(name);
            },
            updateFilters: function (event, filtertype) {
                this.$parent.updateFilters(event,filtertype);
            },
            checkedFacetsCount: function (key) {
                return this.$parent.checkedFacetsCount(key);
            },
            resetFilters: function (event) {
                this.$parent.resetFilters(event);
            },
            isFilterValueChecked: function (facet, value) {
                return this.$parent.isFilterValueChecked(facet,value);
            },
            toggleFilter: function (event) {
                this.$parent.toggleFilter(event);
            },
            closeFilter: function () {
                this.$parent.closeFilter();
            },
            previousPage(){
                this.$parent.previousPage();
            },
            setCurrentPageByEvent($event){
                this.$parent.setCurrentPageByEvent($event);
            },
            nextPage(){
                this.$parent.nextPage();
            },
        }
    };
    </script>
    